import { Stack, Typography } from "@mui/material";
import { CommentsFeed, DrawerLayout } from "../../../components";
import { CommentSubject } from "../../../constants";
import { GetWikiPageDto } from "../../../http";

interface Props {
  page: GetWikiPageDto;
}

const WikiPageCommentsDrawerContent = (props: Props) => {
  return (
    <DrawerLayout
      title={
        <Stack>
          <Typography variant="h6">CODE OS Conversations</Typography>
          <Typography variant="caption">Take part in the evolution of the CODE OS</Typography>
        </Stack>
      }
    >
      <CommentsFeed subjectType={CommentSubject.WikiPage} subjectGuid={props.page.wikiPageGuid} />
    </DrawerLayout>
  );
};

export { WikiPageCommentsDrawerContent };
